import NeurogenicTremoringFlow from "@/components/Exercises/Body-Exercise/NeurogenicTremoringFlow";
import neurogenicTremoringAudio from "@/assets/audios/neurogenic-tremoring.m4a";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/neurogenic-tremoring/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Neurogenic Tremoring Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "neurogenicTremoring.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showFlow, setShowFlow] = useState(false);

  const startExercise = () => setShowFlow(true);
  const closeFlow = () => setShowFlow(false);

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="neurogenicTremoring.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="neurogenicTremoring.intro" />
      </p>
      <MediaPlayer
        src={neurogenicTremoringAudio}
        segment={{ start: 0, end: 53 }}
        isPaused={showFlow}
      />
      <NeurogenicTremoringFlow
        onComplete={closeFlow}
        onExit={closeFlow}
        isShow={showFlow}
      />
    </ExerciseLayout>
  );
}
